import { ManageQaPage as ManageQa } from 'modules/Workspace/components/ManageQA';
const ManageQaPage = () => <ManageQa />;
export default ManageQaPage;
